import { Icon } from '@aibees/shared/components';
import { ComingSoonTag } from '@aibees/shared/components/coming-soon-tag';
import { usePathname } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SettingsMenuItemProps as Props } from './types';

export const SettingsMenuItem = memo(({ className, item, onClick }: Props) => {
  const pathname = usePathname();
  const active = pathname.startsWith(item.linkTo ?? '#');
  let iconColor = 'grey.600';
  if (active) iconColor = 'primary.500';
  if (item.comingSoon) iconColor = 'grey.400';

  return (
    <Styled.Wrapper
      className={classnames('SettingsMenuItem', className, { active })}
      sx={SX.root}
      disabled={item.disabled || item.comingSoon}
      onClick={() => onClick(item.linkTo ?? '#', item)}
    >
      <Styled.FlexBox>
        {!!item.icon && <Icon name={item.icon} color={iconColor} size={20} />}
        <Typography variant="body4" fontWeight={500}>
          {item.label}
        </Typography>
      </Styled.FlexBox>
      {item.externalLink && (
        <Styled.FlexBox>
          <Icon name="external-link" color="grey.400" size={20} />
        </Styled.FlexBox>
      )}
      {item.comingSoon && (
        <Styled.FlexBox>
          <ComingSoonTag />
        </Styled.FlexBox>
      )}
    </Styled.Wrapper>
  );
});

SettingsMenuItem.displayName = 'SettingsMenuItem';
